import { useQuery } from '@redwoodjs/web';

import { showErrorLong } from 'src/components/Toasts/toast';
import { GET_LEDGER_ACCOUNTS } from 'src/graphql/queries/getLedgerAccounts.query';

const useGetLedgerAccounts = () => {
    const { data, loading, error } = useQuery(GET_LEDGER_ACCOUNTS, {
        fetchPolicy: 'cache-first',
    });

    if (error?.message) {
        showErrorLong(error.message);
        console.error(error.message);
    }
    return {
        fetchingLedgerAccounts: loading,
        ledgerAccounts: data?.getLedgerAccounts ?? [],
    };
};

export default useGetLedgerAccounts;
